import '@ssml-editor/core';
import { MenuBaseService, EditorUtils } from '@ssml-editor/vue';
import '../../module/phoneme/alphabet.enum.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import { SPEAK_TYPE } from '../../module/speak/constant.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
/* empty css                                                                                                                                             */
/* empty css                */
/* empty css                  */
/* empty css              */
/* empty css                           */
/* empty css                      */
/* empty css                  */
import '../voice/voice-menu.vue.js';
import { l as lodashExports } from '../../../_virtual/lodash.js';

class SpeakMenuService extends MenuBaseService {
  isDisabled() {
    if (super.isDisabled()) return true;
    const { selection } = this.editor;
    if (!selection) return true;
    return false;
  }
  getNodeAsSpeakContentData() {
    const node = EditorUtils.findSelectedNodeByType(this.editor, SPEAK_TYPE);
    if (node) {
      const speakNode = node;
      return {
        rate: speakNode.rate,
        pitch: speakNode.pitch,
        volume: speakNode.volume,
        bgmVolume: speakNode.bgmVolume || 100,
        effect: speakNode.effect,
        effectValue: speakNode.effectValue,
        bgm: speakNode.bgm,
        bgmName: speakNode.bgmName
      };
    }
  }
  setNode(data) {
    if (!this.isDisabled()) {
      const textNode = EditorUtils.findSelectedTextNode(this.editor);
      if (textNode) {
        const value = textNode.text;
        if (value) {
          const element = {
            type: SPEAK_TYPE,
            mark: data.label || "",
            rate: data.rate,
            pitch: data.pitch,
            volume: data.volume,
            effect: data.effect,
            effectValue: data.effectValue,
            bgm: data.bgm,
            bgmName: data.bgmName,
            bgmVolume: data.bgmVolume,
            children: []
          };
          const node = EditorUtils.findSelectedNodeByType(
            this.editor,
            SPEAK_TYPE
          );
          if (node) {
            const partialElement = element;
            delete partialElement.children;
            delete partialElement.type;
            EditorUtils.replaceNode(this.editor, node, partialElement);
          } else {
            const topNode = EditorUtils.findTopNode(this.editor, textNode);
            if (topNode) {
              element.children = lodashExports.cloneDeep(topNode.children);
              EditorUtils.replaceNode(this.editor, topNode, element);
            }
          }
        }
      }
    }
  }
}

export { SpeakMenuService };
//# sourceMappingURL=speak-menu-service.js.map
